import { Components, Theme } from '@mui/material';

export const MuiFormControl: Components<Theme>['MuiFormControl'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'small',
  },
};
